import { useEffect } from "react";
import { PaletteMode, ThemeOptions } from "@mui/material/styles";
import { useKeycloak } from "@react-keycloak/web";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import App from "../../app/App";
import { useSelector } from "../../app/helpers";
import { RootState } from "../../app/rootReducer";
import { PrivateRoute } from "./private-route.component";
import { LoadingAnimation } from "../Animations/loadingAnimation.componenet";

type P = {
  setColorMode: React.Dispatch<React.SetStateAction<PaletteMode>>;
  setTheme: React.Dispatch<React.SetStateAction<ThemeOptions>>;
  setBrandColor: React.Dispatch<React.SetStateAction<string>>;
  themeColor: string;
};

const AppRouter: React.FC<P> = ({ setColorMode, setBrandColor, setTheme }) => {
  const {
    settings: { colorMode }
  } = useSelector((state: RootState) => state.login);
  const { initialized } = useKeycloak();

  useEffect(() => {
    if (colorMode) setColorMode(colorMode);
  }, [colorMode]);

  if (!initialized) return <LoadingAnimation />;

  return (
    <Router>
      <Switch>
        <PrivateRoute setBrandColor={setBrandColor} setTheme={setTheme} path="/" component={App} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
